import { Component, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NotificationService, Notification, NotificationComponent, DialogService } from '../../../shared/index'; //app/shared/index barrel;
import { ActivatedRoute } from '@angular/router';
import { EventsService } from '../../shared/events.service';
import { ConfigService } from '../../../config/shared/config.service';
import { EventRead } from '../../shared/event-read.model';
import { EventCopy } from '../../shared/event-copy.model';
import { Router } from '@angular/router';
import { RegistrationWizardComponent } from '../../registration/wizard/registration-wizard.component';

@Component({
  selector: 'wl-event-new-registration',
  templateUrl: 'new-registration.component.html',
  providers: [EventsService, ConfigService],
    standalone: false
})
export class EventNewRegistrationComponent {
  @ViewChild('registrationWizard', { static: false }) registrationWizard: RegistrationWizardComponent;

  @Output() onRegistrationSaved = new EventEmitter<number>();

  public _eventsService: EventsService;
  public _dialogService: DialogService;
  public _configService: ConfigService;
  public _translateService: TranslateService;
  public _router: Router;
  public _route: ActivatedRoute;

  public id: number;
  @Input() public event: EventRead;
  public eventUrl: string;
  public copyMessage: string;
  public updatingEvent: boolean = false;

  constructor(
    route: ActivatedRoute,
    eventsService: EventsService,
    dialogService: DialogService,
    configService: ConfigService,
    translateService: TranslateService,
    router: Router
  ) {
    this._route = route;
    this._eventsService = eventsService;
    this._dialogService = dialogService;
    this._configService = configService;
    this._translateService = translateService;
    this._router = router;

    this.event = new EventRead();
    this.updatingEvent = false;
  }

  ngOnInit() {
    this._route.paramMap
      //.map(params => params['id'])
      .subscribe(params => {
        this.id = parseInt(params.get('id'));
        this.updateEvent(this.id);
      });
  }

  public updateEvent(eventId: number) {
    this.updatingEvent = true;
    this._eventsService.getEventRead(eventId).then(
      (data: EventRead) => {
        this.event = data;
        this.updatingEvent = false;
      },
      () => {
        this.updatingEvent = false;
      }
    );
  }

  public newRegistration = (): void => {
    this.registrationWizard.openRegistrationWizard(this.event, 0);
  };

  public registrationSaved = (registrationId: number) => {
    this.onRegistrationSaved.emit(registrationId);
  };
}
